import * as React from 'react';
import type { JsonObject } from '@/app-package';
import { ListingDoc } from '@bb/domain/dist/schemas';

import DataSetsTable from './DataSetsTable';

type RequiredListProps = { requiredItems: JsonObject<ListingDoc>['required'] };

const RequiredList: React.FunctionComponent<RequiredListProps> = ({
  requiredItems,
}) => {
  const requiredItemDataSets = [
    [
      { label: 'Lease Term:', value: requiredItems?.lease_term },
      {
        label: 'Rental Application:',
        value: requiredItems?.rental_application,
      },
      { label: 'Deposit Required:', value: requiredItems?.deposit },
    ],
    [
      { label: 'Credit Check:', value: requiredItems?.credit_check },
      { label: 'Employment Letter:', value: requiredItems?.employment_letter },
      { label: 'Payment Method:', value: requiredItems?.payment_method },
    ],
  ];

  return (
    <DataSetsTable dataSets={requiredItemDataSets} columnClassName="col-md-5" />
  );
};

export default RequiredList;
